module.exports = __webpack_public_path__ + "static/img/brian_1000.3e30ec3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/team/brian_1000.jpg
// module id = M3oV
// module chunks = 1